import {
  Assignment,
  CommuteOutlined,
  Redeem,
  ScaleOutlined,
  WorkOutlineTwoTone,
} from "@mui/icons-material";
import HandymanIcon from "@mui/icons-material/Handyman";
import { Box, Stack } from "@mui/material";

import {
  capitalizeFirst,
  formatText,
  formatWeightLb,
  getCommdityNameForCondensedShipmentShipment,
  getEquipmentTypesDisplay as getEquipmentTypesAsSingleString,
  getServiceTypeDisplayLabel,
} from "utils";

import { ShipmentDetail } from "../../../../../../Shipment/components/ShipmentDetail";
import { BookedCarrierSection } from "../BookedCarrierSection";
import { SupplierInformationSection } from "../SupplierInformationSection";
import { SupplierShipmentDetailFiles } from "../SupplierShipmentDetailFiles";

interface Props {
  shipment: SupplierShipment | undefined;
}

export function SupplierShipmentDetails(props: Props) {
  const { shipment } = props;

  const shipmentInfo = shipment?.info;
  const equipmentTypes = shipment?.equipments;

  const getEquipmentTypesDisplay = () => {
    if (!equipmentTypes) {
      return "";
    }
    const equipmentTypeNames = equipmentTypes.map((eq) => eq.name);
    return getEquipmentTypesAsSingleString(equipmentTypeNames);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
        <ShipmentDetail
          icon={<Redeem />}
          title="Commodity"
          text={
            shipment?.info
              ? capitalizeFirst(
                  formatText(
                    getCommdityNameForCondensedShipmentShipment(shipment.info),
                  ),
                )
              : "-"
          }
        />
        <ShipmentDetail
          icon={<ScaleOutlined fontSize="small" />}
          title="Weight"
          text={
            shipmentInfo?.weight_lb != null
              ? formatWeightLb(shipmentInfo.weight_lb)
              : "-"
          }
        />
        <ShipmentDetail
          icon={<WorkOutlineTwoTone fontSize="small" />}
          title="Service"
          text={getServiceTypeDisplayLabel(shipmentInfo?.service ?? "-")}
        />
        <ShipmentDetail
          icon={<CommuteOutlined fontSize="small" />}
          title="Equipment Type(s)"
          text={
            equipmentTypes && equipmentTypes.length > 0
              ? getEquipmentTypesDisplay()
              : "-"
          }
        />
        <ShipmentDetail
          icon={<Assignment fontSize="small" />}
          title="Product Dimensions"
          multiline
          text={shipment?.info?.additional_details ?? "-"}
        />
        <ShipmentDetail
          icon={<HandymanIcon fontSize="small" />}
          title="Special Requirements"
          multiline
          text={shipment?.info?.special_requirements ?? "-"}
        />
      </Box>

      <Stack
        direction="row"
        spacing={3}
        flexWrap="wrap"
        sx={{ justifyContent: "space-between" }}
      >
        <SupplierInformationSection shipment={shipment} />
        <BookedCarrierSection shipment={shipment} />
      </Stack>

      <SupplierShipmentDetailFiles shipmentId={shipment?.info?.id} />
    </Stack>
  );
}
